export enum BulkImportUserResultType {
  ProcessErrors = 'process-errors',
  SummaryErrors = 'summary-errors',
  SummaryToBeDeleted = 'summary-to-be-deleted',
}
